unit View.Status_Titulos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewStatus_TitulosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbpermite_alterar: TLabel;
    edpermite_alterar: TDBEdit;
    lbpermite_baixar: TLabel;
    edpermite_baixar: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientStatus_TitulosGet: TXDataWebClient;
    XDataClientStatus_TitulosDelete: TXDataWebClient;
    Status_TitulosDataset: TXDataWebDataSet;
    Status_TitulosDatasetid: TIntegerField;
    Status_TitulosDatasetnome: TStringField;
    Status_TitulosDatasetpermite_alterar: TBooleanField;
    Status_TitulosDatasetpermite_baixar: TBooleanField;
    Status_TitulosDatasetexcluido: TBooleanField;
    Status_TitulosDatasetinclusao: TDateTimeField;
    Status_TitulosDatasetalteracao: TDateTimeField;
    Status_TitulosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientStatus_TitulosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientStatus_TitulosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientStatus_TitulosDeleteError(Error: TXDataClientError);
    procedure Status_TitulosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewStatus_TitulosEdit: TFViewStatus_TitulosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewStatus_TitulosEdit }

procedure TFViewStatus_TitulosEdit.btSaveClick(Sender: TObject);
begin
  if Status_TitulosDataset.State in dsEditModes then
  begin
        Status_TitulosDataset.Post;
    Status_TitulosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewStatus_TitulosEdit.btDeleteClick(Sender: TObject);
begin
  if Status_TitulosDataset.State in dsEditModes then
    Status_TitulosDataset.Post;
  XDataClientStatus_TitulosDelete.Delete(Status_TitulosDataset.EntitySetName,
    TJSObject(Status_TitulosDataset.CurrentData));
end;


class function TFViewStatus_TitulosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewStatus_TitulosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewStatus_TitulosEdit.InsertEntity;
begin
  Status_TitulosDataset.Close;
  Status_TitulosDataset.SetJsonData('{}');
  Status_TitulosDataset.Open;
  Status_TitulosDataset.Insert;
end;

class function TFViewStatus_TitulosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewStatus_TitulosEdit(AForm).FInserting := AInserting;
    TFViewStatus_TitulosEdit(AForm).FId := AId;
    TFViewStatus_TitulosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewStatus_TitulosEdit(AForm).InsertEntity
    else
      TFViewStatus_TitulosEdit(AForm).LoadEntity;
    TFViewStatus_TitulosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewStatus_TitulosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewStatus_TitulosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Status_TitulosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Status_TitulosDataset.EntitySetName
    )
  );
  XDataClientStatus_TitulosGet.Get(Status_TitulosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewStatus_TitulosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewStatus_TitulosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewStatus_TitulosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewStatus_TitulosEdit.XDataClientStatus_TitulosGetLoad(Response: TXDataClientResponse);
begin
  Status_TitulosDataset.Close;
  Status_TitulosDataset.SetJsonData(Response.Result);
  Status_TitulosDataset.Open;
  
  Status_TitulosDataset.Edit;  
end;

procedure TFViewStatus_TitulosEdit.XDataClientStatus_TitulosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewStatus_TitulosEdit.XDataClientStatus_TitulosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewStatus_TitulosEdit.Status_TitulosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewStatus_TitulosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewStatus_TitulosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.status_titulos.form.message');
  lbMessage := TLabel.Create('view.status_titulos.form.message.label');
  btCloseMessage := TButton.Create('view.status_titulos.form.message.button');
  btCancel := TButton.Create('view.status_titulos.form.btBack');
  btSave := TButton.Create('view.status_titulos.form.btSave');
  btDelete := TButton.Create('view.status_titulos.form.btDelete');
  lbid := TLabel.Create('view.status_titulos.form.lbid');
  edid := TDBEdit.Create('view.status_titulos.form.edid');
  lbnome := TLabel.Create('view.status_titulos.form.lbnome');
  ednome := TDBEdit.Create('view.status_titulos.form.ednome');
  lbpermite_alterar := TLabel.Create('view.status_titulos.form.lbpermite_alterar');
  edpermite_alterar := TDBEdit.Create('view.status_titulos.form.edpermite_alterar');
  lbpermite_baixar := TLabel.Create('view.status_titulos.form.lbpermite_baixar');
  edpermite_baixar := TDBEdit.Create('view.status_titulos.form.edpermite_baixar');
  lbexcluido := TLabel.Create('view.status_titulos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.status_titulos.form.edexcluido');
  lbinclusao := TLabel.Create('view.status_titulos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.status_titulos.form.edinclusao');
  lbalteracao := TLabel.Create('view.status_titulos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.status_titulos.form.edalteracao');
  lbexclusao := TLabel.Create('view.status_titulos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.status_titulos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Status_TitulosDataset := TXDataWebDataSet.Create(Self);
  Status_TitulosDatasetid := TIntegerField.Create(Self);
  Status_TitulosDatasetnome := TStringField.Create(Self);
  Status_TitulosDatasetpermite_alterar := TBooleanField.Create(Self);
  Status_TitulosDatasetpermite_baixar := TBooleanField.Create(Self);
  Status_TitulosDatasetexcluido := TBooleanField.Create(Self);
  Status_TitulosDatasetinclusao := TDateTimeField.Create(Self);
  Status_TitulosDatasetalteracao := TDateTimeField.Create(Self);
  Status_TitulosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientStatus_TitulosGet := TXDataWebClient.Create(Self);
  XDataClientStatus_TitulosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbpermite_alterar.BeforeLoadDFMValues;
  edpermite_alterar.BeforeLoadDFMValues;
  lbpermite_baixar.BeforeLoadDFMValues;
  edpermite_baixar.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Status_TitulosDataset.BeforeLoadDFMValues;
  Status_TitulosDatasetid.BeforeLoadDFMValues;
  Status_TitulosDatasetnome.BeforeLoadDFMValues;
  Status_TitulosDatasetpermite_alterar.BeforeLoadDFMValues;
  Status_TitulosDatasetpermite_baixar.BeforeLoadDFMValues;
  Status_TitulosDatasetexcluido.BeforeLoadDFMValues;
  Status_TitulosDatasetinclusao.BeforeLoadDFMValues;
  Status_TitulosDatasetalteracao.BeforeLoadDFMValues;
  Status_TitulosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientStatus_TitulosGet.BeforeLoadDFMValues;
  XDataClientStatus_TitulosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewStatus_TitulosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 481;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 421;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 421;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 421;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbpermite_alterar.SetParentComponent(Self);
    lbpermite_alterar.Name := 'lbpermite_alterar';
    lbpermite_alterar.Left := 24;
    lbpermite_alterar.Top := 246;
    lbpermite_alterar.Width := 14;
    lbpermite_alterar.Height := 13;
    lbpermite_alterar.Caption := 'permite_alterar:';
    lbpermite_alterar.Transparent := True;
    edpermite_alterar.SetParentComponent(Self);
    edpermite_alterar.Name := 'edpermite_alterar';
    edpermite_alterar.Left := 221;
    edpermite_alterar.Top := 243;
    edpermite_alterar.Width := 200;
    edpermite_alterar.Height := 21;
    edpermite_alterar.Enabled := True;
    edpermite_alterar.TabOrder := 8;
    edpermite_alterar.Text := 'edpermite_alterar';
    edpermite_alterar.DataField := 'permite_alterar';
    edpermite_alterar.DataSource := DataSource;
    lbpermite_baixar.SetParentComponent(Self);
    lbpermite_baixar.Name := 'lbpermite_baixar';
    lbpermite_baixar.Left := 24;
    lbpermite_baixar.Top := 273;
    lbpermite_baixar.Width := 14;
    lbpermite_baixar.Height := 13;
    lbpermite_baixar.Caption := 'permite_baixar:';
    lbpermite_baixar.Transparent := True;
    edpermite_baixar.SetParentComponent(Self);
    edpermite_baixar.Name := 'edpermite_baixar';
    edpermite_baixar.Left := 221;
    edpermite_baixar.Top := 270;
    edpermite_baixar.Width := 200;
    edpermite_baixar.Height := 21;
    edpermite_baixar.Enabled := True;
    edpermite_baixar.TabOrder := 9;
    edpermite_baixar.Text := 'edpermite_baixar';
    edpermite_baixar.DataField := 'permite_baixar';
    edpermite_baixar.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 300;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 297;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 10;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 327;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 324;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 11;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 354;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 351;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 12;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 381;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 378;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 13;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Status_TitulosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Status_TitulosDataset.SetParentComponent(Self);
    Status_TitulosDataset.Name := 'Status_TitulosDataset';
    Status_TitulosDataset.AfterApplyUpdates := Status_TitulosDatasetAfterApplyUpdates;
    Status_TitulosDataset.EntitySetName := 'Status_Titulos';
    Status_TitulosDataset.Connection := DMConnection.ApiConnection;
    Status_TitulosDataset.Left := 176;
    Status_TitulosDataset.Top := 8;
    Status_TitulosDatasetid.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetid.Name := 'Status_TitulosDatasetid';
    Status_TitulosDatasetid.FieldName := 'id';
    Status_TitulosDatasetid.Required := True;
    Status_TitulosDatasetnome.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetnome.Name := 'Status_TitulosDatasetnome';
    Status_TitulosDatasetnome.FieldName := 'nome';
    Status_TitulosDatasetnome.Required := True;
    Status_TitulosDatasetnome.Size := 255;
    Status_TitulosDatasetpermite_alterar.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetpermite_alterar.Name := 'Status_TitulosDatasetpermite_alterar';
    Status_TitulosDatasetpermite_alterar.FieldName := 'permite_alterar';
    Status_TitulosDatasetpermite_alterar.Required := True;
    Status_TitulosDatasetpermite_baixar.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetpermite_baixar.Name := 'Status_TitulosDatasetpermite_baixar';
    Status_TitulosDatasetpermite_baixar.FieldName := 'permite_baixar';
    Status_TitulosDatasetpermite_baixar.Required := True;
    Status_TitulosDatasetexcluido.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetexcluido.Name := 'Status_TitulosDatasetexcluido';
    Status_TitulosDatasetexcluido.FieldName := 'excluido';
    Status_TitulosDatasetexcluido.Required := False;
    Status_TitulosDatasetinclusao.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetinclusao.Name := 'Status_TitulosDatasetinclusao';
    Status_TitulosDatasetinclusao.FieldName := 'inclusao';
    Status_TitulosDatasetinclusao.Required := False;
    Status_TitulosDatasetalteracao.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetalteracao.Name := 'Status_TitulosDatasetalteracao';
    Status_TitulosDatasetalteracao.FieldName := 'alteracao';
    Status_TitulosDatasetalteracao.Required := False;
    Status_TitulosDatasetexclusao.SetParentComponent(Status_TitulosDataset);
    Status_TitulosDatasetexclusao.Name := 'Status_TitulosDatasetexclusao';
    Status_TitulosDatasetexclusao.FieldName := 'exclusao';
    Status_TitulosDatasetexclusao.Required := False;
    XDataClientStatus_TitulosGet.SetParentComponent(Self);
    XDataClientStatus_TitulosGet.Name := 'XDataClientStatus_TitulosGet';
    XDataClientStatus_TitulosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientStatus_TitulosGet, Self, 'OnLoad', 'XDataClientStatus_TitulosGetLoad');
    XDataClientStatus_TitulosGet.Left := 64;
    XDataClientStatus_TitulosGet.Top := 8;
    XDataClientStatus_TitulosDelete.SetParentComponent(Self);
    XDataClientStatus_TitulosDelete.Name := 'XDataClientStatus_TitulosDelete';
    XDataClientStatus_TitulosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientStatus_TitulosDelete, Self, 'OnLoad', 'XDataClientStatus_TitulosDeleteLoad');
    SetEvent(XDataClientStatus_TitulosDelete, Self, 'OnError', 'XDataClientStatus_TitulosDeleteError');
    XDataClientStatus_TitulosDelete.Left := 64;
    XDataClientStatus_TitulosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbpermite_alterar.AfterLoadDFMValues;
    edpermite_alterar.AfterLoadDFMValues;
    lbpermite_baixar.AfterLoadDFMValues;
    edpermite_baixar.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Status_TitulosDataset.AfterLoadDFMValues;
    Status_TitulosDatasetid.AfterLoadDFMValues;
    Status_TitulosDatasetnome.AfterLoadDFMValues;
    Status_TitulosDatasetpermite_alterar.AfterLoadDFMValues;
    Status_TitulosDatasetpermite_baixar.AfterLoadDFMValues;
    Status_TitulosDatasetexcluido.AfterLoadDFMValues;
    Status_TitulosDatasetinclusao.AfterLoadDFMValues;
    Status_TitulosDatasetalteracao.AfterLoadDFMValues;
    Status_TitulosDatasetexclusao.AfterLoadDFMValues;
    XDataClientStatus_TitulosGet.AfterLoadDFMValues;
    XDataClientStatus_TitulosDelete.AfterLoadDFMValues;
  end;
end;

end.
